"use strict";

exports.__esModule = true;
var practiceAutocompleteTransformer = exports.practiceAutocompleteTransformer = function practiceAutocompleteTransformer(practice) {
	return {
		city: practice.city,
		doctifyId: practice.doctifyId,
		id: practice.id,
		type: practice.type,
		uriId: practice.uri_id,
		name: practice.name
	};
};